import { Component, OnInit } from '@angular/core';
import { Pwa } from '@freelancer/pwa';
import { ModalService } from '../modal/modal.service';

@Component({
  selector: 'fl-update-native-alert',
  template: ``,
})
export class UpdateNativeAlertComponent implements OnInit {
  constructor(private pwa: Pwa, private modalService: ModalService) {}

  async ngOnInit() {
    if (
      this.pwa.isNative() &&
      !(await this.pwa.hasMinimumNativeVersion({
        major: 4,
        minor: 0,
      }))
    ) {
      this.modalService.open('UpdateNativeModal', {
        closeable: false,
      });
    }
  }
}
